<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <MyForm
      ref="form"
      :form="form"
      :rules="rules"
      :labelWidth="labelWidth"
      :formGroups="[{ formCtrl }]"
      :viewMode="viewMode"
      @onChange="onChange"
    >
    </MyForm>

    <div class="btns">
      <SubmitBtn
        v-if="mode != 'view'"
        :editMode="mode === 'edit'"
        @onSubmit="onSubmit"
      ></SubmitBtn>
      <el-button @click="cancel">取 消</el-button>
    </div>
  </div>
</template>

<script>
import detailMixin from "../../mixin/detail";

export default {
  mixins: [detailMixin],
  data() {
    return {
      breadcrumb: [
        { name: "车辆管理", path: `/vehicle/maintain` },
        { name: "车辆维护", path: `/vehicle/maintain` },
        { name: "车辆添加" },
      ],
      baseUrl: "carmaintenance",
      form: {
        license: undefined,
        driver: undefined,
        maintenance_type: "一级维护",
        maintenance_date: undefined,
        expire_date: undefined,
        agency_id: undefined,
        photo: undefined,
        remark: undefined,
      },
      formCtrl: [
        {
          label: "车牌号",
          keyName: "license",
          type: "textSelect",
          options: [],
        },
        {
          label: "司机姓名",
          keyName: "driver",
          err: "请填写司机姓名",
          type: "text",
          disabled: true,
        },
        {
          label: "维护类型",
          keyName: "maintenance_type",
          type: "select",
          err: "请选择维护类型",
          options: [
            {
              label: "一级维护",
              value: "一级维护",
            },
            {
              label: "二级维护",
              value: "二级维护",
            },
          ],
        },
        {
          label: "维护日期",
          keyName: "maintenance_date",
          err: "请选择维护日期",
          type: "date",
        },
        {
          label: "到期日期",
          keyName: "expire_date",
          err: "请选择到期日期",
          type: "date",
        },
        {
          label: "维护机构",
          keyName: "agency_id",
          err: "请选择维护机构",
          type: "select",
          options: [],
        },
        {
          label: "维护照片",
          keyName: "photo",
          type: "file",
          ptype: "repair",
          className: "block",
          tips: "最多上传15张图片",
          max: 15,
        },
        {
          label: "备注",
          keyName: "remark",
          err: "请填写内容",
          type: "textarea",
          rows: "3",
          className: "block",
        },
      ],
      rules: {
        license: [
          {
            required: true,
            message: "请填写车牌号",
            trigger: ["blur", "change"],
          },
        ],
        maintenance_date: [
          {
            required: true,
            message: "请选择维护日期",
            trigger: "blur",
          },
        ],
        expire_date: [
          {
            required: true,
            message: "请选择维护日期",
            trigger: "blur",
          },
        ],
        agency_id: [
          {
            required: true,
            message: "请选择维护机构",
            trigger: "blur",
          },
        ],
      },
      car_list: [],
    };
  },
  methods: {
    setOptions({ car_list, agency_list }) {
      // console.log(car_list, agency_list);
      this.formCtrl.map((c) => {
        // console.log(c);
        if (c.label == "车牌号" && car_list && car_list.length) {
          this.car_list = car_list;
          c.options = car_list.map((v) => {
            return {
              label: v.license,
              value: v.license,
            };
          });
        }
        if (c.keyName == "agency_id" && agency_list && agency_list.length) {
          c.options = agency_list.map((v) => {
            return {
              label: v.name,
              value: v.id,
            };
          });
        }
      });
      this.$forceUpdate();
      // console.log({ ...this.form })
    },

    onChange({ key, value }) {
      // console.log(key, value)
      if (key === "license") {
        console.log(key, value);
        // this.form[key] = value;
        this.$set(this.form, key, value);
        this.car_list.map((v) => {
          if (v.license === value) {
            this.$set(this.form, "car_id", v.id);
            this.$set(this.form, "driver_id", v.driverid);
            this.$set(this.form, "driver", v.driver);
          }
        });
      } else if (key.includes("photo")) {
        this.form[key] = value.map((v) => {
          let result = v;
          if (v.response && v.response.photo) {
            result = {
              url: v.response.photo,
            };
          }
          return result;
        });
      } else {
        this.form[key] = value;
      }
      console.log({ ...this.form });
    },
  },
  mounted() {
    const { id, car_id, driver_id } = this.$route.query;
    if (id) {
      this.form.car_id = car_id;
      this.form.driver_id = driver_id;
      this.formCtrl.map((v) => {
        if (v.label === "车牌号") {
          v.disabled = true;
        }
      });
      console.log([...this.formCtrl]);
    }
    this.getOptions();
  },
};
</script>

<style lang="less" scoped>
.btns {
  margin: 40px 0 60px 180px;
}
</style>
